import ComparisonPdfPayload from '../../../../entities/ComparisonPdfPayload'
import { translate } from '../../../../i18n/translate'

const translateName = (id: string, translationKey: string, fallbackName: string): string => {
    const translatedValue = translate(translationKey)
    return translatedValue !== null ? translatedValue : fallbackName
}

const translateInfo = (value: string): string => {
    if (typeof value === 'number' || typeof value === 'boolean' || value.includes('http://') || value.includes('https://')) {
        return value
    }
    const translationKey = `compare.info.${value}`
    const translatedValue = translate(translationKey)
    return translatedValue !== null ? translatedValue : value
}

const translateCategory = (category: any): any => {
    const translatedCategoryName = translateName(
        category.id,
        `compare.categories.${category.id}`,
        category.name,
    )

    if (category.id === 'model') {
        return {
            ...category,
            name: translatedCategoryName,
            subCategory: category.subCategory.map((subcategory: any) => ({
                ...subcategory,
                name: subcategory.name,
                rows: subcategory.rows.map((row: any) => ({
                    ...row,
                    name: translateName(row.id, `compare.rows.${row.id}`, row.name),
                    columns: row.columns,
                })),
            })),
        }
    }

    return {
        ...category,
        name: translatedCategoryName,
        subCategory: category.subCategory,
    }
}

const translateMetadataInfo = (info: any): any => {
    if (!info || typeof info !== 'object') {
        return info
    }
    return Object.keys(info).reduce((result: any, key: string) => {
        if (typeof info[key] === 'string') {
            result[key] = translateInfo(info[key])
        } else {
            result[key] = info[key]
        }
        return result
    }, {})
}

const getTranslatedComparisonPdfPayload = (obj: ComparisonPdfPayload): ComparisonPdfPayload => {
    return {
        ...obj,
        categories: obj.categories?.map(translateCategory),
        info: obj.info,
        metadata: obj.metadata ? {
            ...obj.metadata,
            info: obj.metadata.info ? translateMetadataInfo(obj.metadata.info) : obj.metadata.info,
        } : obj.metadata,
    }
}

export default getTranslatedComparisonPdfPayload
